const SUPPORTED_AUDIENCES = [
    'teetime-web',
    'teetime-admin',
    'billing-admin',
    'control-admin',
    'messaging-admin',
    'cmp-portal',
    'voicepro-web',
    'scl-admin',
    'facilities-admin',
    'yolo-admin',
];
function asAudience(value) {
    const audience = value?.trim();
    if (!audience)
        return undefined;
    return SUPPORTED_AUDIENCES.includes(audience) ? audience : undefined;
}
export function resolveAudience() {
    // 1) Meta tag
    if (typeof document !== 'undefined') {
        const meta = document.querySelector('meta[name="idp-audience"]');
        const audience = asAudience(meta?.content);
        if (audience)
            return audience;
    }
    // 2) Window config
    if (typeof window !== 'undefined') {
        const w = window;
        const audience = asAudience(w.APP_CONFIG?.idpAudience);
        if (audience)
            return audience;
    }
    const env = globalThis.process?.env;
    return asAudience(env?.['VITE_IDP_AUDIENCE']) ?? 'teetime-web';
}
//# sourceMappingURL=resolveAudience.js.map